import script from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"

import "./BaseIcon.vue?vue&type=style&index=0&id=380d05d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380d05d4"]])

export default __exports__